import React from "react";
  import GreenBorderline from "../updatehackinginternship/Assets/ProcessAssets/skgreenborder.png";
// 1. Updated courseData with a 'description' for each card
const courseData = [
  { 
    title: "System Hacking", 
    image: "https://i.pinimg.com/736x/57/f3/7b/57f37b2b51d9b1e7f8ba92ced299bb7e.jpg",
    description: "Learn to find and exploit vulnerabilities in operating systems."
  },
  { 
    title: "Mobile Hacking", 
    image: "https://www.nsi.org/wp-content/uploads/18feb21a.jpg",
    description: "Discover security flaws in Android and iOS applications."
  },
  { 
    title: "Website Hacking", 
    image: "https://i.pinimg.com/736x/c2/f8/d6/c2f8d63d8141fbf4d75a9f5f0d71dd88.jpg",
    description: "Master SQL injection, XSS, and other web attack vectors."
  },
  { 
    title: "Bug Bounty Hunting", 
    image: "https://i.pinimg.com/1200x/56/f6/57/56f657244d4a54836392a1f37ba9c3ab.jpg",
    description: "Get paid to find bugs in real-world applications."
  },
  { 
    title: "Password Cracking", 
    image: "https://i.pinimg.com/1200x/7c/20/d9/7c20d90e16dd384451dc20ec2ca0f529.jpg",
    description: "Explore techniques for bypassing and cracking password hashes."
  },
  { 
    title: "Wi-Fi Hacking", 
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuC-T1E2e331rfMVgEwhV6uAOFHiy_rKlvlMuatAJh8u2T6U7FKOedI7fmmyfPwsm_ITwCkOdyGRLlLKBx79aIvOngRAKgP8yVCg58tJg1AvSnTsqipEL-Jgd4cPt0lxvGP7-BsOVzlC0QaqFHG3XXeEa0g5I6vw1k5tuz8NraaNNJPFf1ZyG5Yy6YCKxRTsNTPqA4qlHPWfy8LAzD7DRu3UcMHA1hcBHsxX25Ax1GA8S7k8KzJQS01fuRNXjSE4h-W0XZAMbF3IHNY",
    description: "Understand WPA2/WPA3 vulnerabilities and wireless security."
  },
 
  { 
    title: "Flipper Zero", 
    image: "https://i.pinimg.com/736x/5f/fe/5d/5ffe5da526664ad04b50457431f7fb32.jpg",
    description: "Master this all-in-one tool for pentesting and hardware hacking."
  },
  { 
    title: "IoT Hacking", 
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuAJ0Nmqwvl-f-W_m-VTkFP2tWdU2w3M1DIvGOuiOpSG6NevyMcWQp0agtjk1Y_kmwoV5dwivvbtF73XNOCcKbkk8UWUeN7fGx4YW2oORThganch6KzYeX8iqGLFuKXwGE1FR59E6aEET1VOy3DzCL1rt7vWE6Jg_7EQJGax0rbnLJJcRhpreizLQPeL60aceDshflIKxSRj0PJ-vLXK8NXWpQNYedF-f8kaPIe93TCbjpde3yrMvMZSJkVY5Z8wQ9_cf5ZktpiqzOo",
    description: "Expose vulnerabilities in smart devices and the Internet of Things."
  },
  { 
    title: "Virus Making", 
    image: "https://i.pinimg.com/1200x/e1/64/b0/e164b0af4bf8eae7efbcc67591683221.jpg",
    description: "Understand malware analysis by learning how they are built."
  },
  { 
    title: "Hacking with AI", 
    image: "https://i.pinimg.com/1200x/35/5c/9b/355c9b1b0736934f94a83995af0c6277.jpg",
    description: "Leverage artificial intelligence for advanced security testing."
  },
  { 
    title: "HackRF", 
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDhGvPRQca6gAD3Sv0wdvxxqZb3e8c64PaSsVkt-42hI8ELfgUdODocPdpqDmfWp3dAK4pky5wi1S5P4RNPYgrmRW6vPwaHJ4QKX9lFwHPX63VNJRvb_8E8c5Jirquk7Am49TnGutHb1BJrFy1Cp7bQeMN2-X1w3K0l36JiUkWisZG2LFgmXlbiaHiGrlhxm_2RERuHZCBpdFkluIEtG_3TtQBJkl9HaVfw94nwijV5ywKzMIC6kg5nNFOabDJDjYfZ-98oN2g6fWI",
    description: "Explore radio frequencies with this powerful Software Defined Radio."
  },
  { 
    title: "Server Hacking", 
    image: "https://i.pinimg.com/736x/aa/d3/08/aad30841a548916f2330ab781fbcfc56.jpg",
    description: "Secure and attack server infrastructures and cloud environments."
  },
  { 
    title: "WhatsApp Hacking", 
    image: "data:image/png;base64,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",
    description: "Analyze traffic and social engineering for messaging apps."
  },
  { 
    title: "Sim Card Cloning", 
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuASCXmhD_8nGBGd6aHMIva7-FMV6GkH-J6wN4a_NCNSvX5aduOkQ1KPAsN23rPJ8giCyMkF6Dc1-laOQDojrYsY66mrxHNuH06OBsu1QalWUS7PziP2JKC3BcaxyH889tSJ1zt_v8g7Oz-5vjFZtMOo07mgnwzVogdsrwiNoD8NhiBmAQNLbHZrSqL_p4yEKr6JYyiXcfkc5KUJt2r7QXOgYm7bGyIZSF1st14NShGrep4qtyqiDVGEUrUuf19zi0A1jaVm_KUIUTo",
    description: "Investigate the techniques and feasibility of SIM card attacks."
  },
  { 
    title: "Drone Hacking", 
    image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDgaPZ_RxN8X3jfJgGUfUhXvW_DN6wnN5JW_NRui69iao527PmLKstAdjm--IDkKFcxu2UAXKcVvsqi_FBJLA1RHdnN5Q17YAQMq5__tE3VfXs9gNGL_cU5anu2qkd8U6DAU6sTcvBbbVcB_4PDl-xbhXqU5ial6I64dWxeHnunqVoGGpFHuzR7P7QRc2T2he_5ZuZ2aW1ZyW3fMfvQza-QdHZm_aFuZhCJlP0E7USf4SkmjBWf4aNZ0iLphOPenBrp2EUqIQR4Tjs",
    description: "Learn to take control of UAVs and secure them from attacks."
  }
];

// 2. CourseCard now accepts 'description' as a prop
const CourseCard = ({ title, image, description }) => {
  return (
    <div className="course-card">
      <div className="card-icon-wrapper">
        <img src={image} alt={title} className="card-image" />
      </div>
      <div className="card-text-content">
        <h3 className="card-title">{title}</h3>
        {/* The hard-coded text is replaced with the 'description' prop */}
        <p className="card-description">
          {description}
        </p>
      </div>
    </div>
  );
};

const HackingTechniques = () => {
  return (
    <div
      className="container-fluid"
      style={{
        minHeight: "100vh",
        backgroundColor: "#e8eaeaff",
        padding: "36px 0",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <style>
        {`
          :root {
            --primary-color: #007BFF;
            --text-title: #111827;
            --text-muted: #6b7280;
            --card-background: #ffffff;
            --shadow-light: 0 4px 12px rgba(0,0,0,0.06);
            --shadow-hover: 0 10px 25px rgba(0,0,0,0.1);
          }
          body { margin: 0; }
          img { user-select: none; -webkit-user-drag: none; }

          .header-title {
            font-size: 2.25rem;
            font-weight: 700;
            color: var(--text-title);
            margin-bottom: 0.5rem;
          }
          .header-subtitle {
            margin: 0;
            color: var(--primary-color);
            font-weight: 600;
            font-size: 1.125rem;
          }

          .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
          }

          /* --- Responsive Grid Container --- */
          .grid-container {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
          }

          /* --- Card Styles (Compact / Side-by-Side) --- */
          .course-card {
            background-color: var(--card-background);
            border-radius: 12px;
            padding: 16px;
            cursor: pointer;
            box-shadow: var(--shadow-light);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            display: flex;
            align-items: center;
            text-align: left;
            min-height: 100px; 
          }
          
          .course-card:hover {
            transform: translateY(-4px);
            box-shadow: var(--shadow-hover);
          }

          /* --- Icon/Image Styles --- */
          .card-icon-wrapper {
            flex-shrink: 0;
            margin-right: 15px;
          }
          .card-image {
            width: 50px;
            height: 50px;
            border-radius: 8px;
            object-fit: cover;
            background-color: #f0f0f0;
            border: 1px solid #e5e7eb;
          }

          /* --- Text Content Styles --- */
          .card-text-content {
            flex-grow: 1;
            min-width: 0;
          }
          
          .card-title {
            font-size: 1.05rem;
            font-weight: 700;
            color: var(--text-title);
            margin: 0 0 4px 0;
            line-height: 1.3;
          }

          .card-description {
            font-size: 0.85rem;
            color: var(--text-muted);
            margin: 0;
            line-height: 1.4;
            display: -webkit-box;
            -webkit-line-clamp: 2; /* Limit to 2 lines */
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
            .tech-header-underline {
          display: block;
          margin: 0 auto; /* Centers the image */
          width: 250px;
          height: 8.59px;
          margin-top: -15px; /* Pulls the image up */
        }
          
          /* --- Media Queries for Responsiveness --- */
          
          @media (max-width: 992px) {
            .grid-container {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          @media (max-width: 640px) {
            .grid-container {
              grid-template-columns: 1fr;
              gap: 16px;
            }
            .header-title {
              font-size: 1.8rem;
            }
          }
        `}
      </style>

      <header style={{ textAlign: "center", marginBottom: 40 }}>
        <div>
          <h1 className="header-title">Featured Hacking Courses</h1>
        
<img
   className="tech-header-underline"
          src={GreenBorderline}
          alt="GreenBorderline"
        />
          <p className="header-subtitle">Kali-Linux - Practically</p>
        </div>
      </header>

      <main>
        <div className="grid-container container">
          {/* 3. Pass the 'c.description' prop to the component */}
          {courseData.map((c, i) => (
            <CourseCard 
              key={i} 
              title={c.title} 
              image={c.image} 
              description={c.description} 
            />
          ))}
        </div>
      </main>
    </div>
  );
};

export default HackingTechniques;